import $ from "jquery";

const currencyFormatter = Intl.NumberFormat("us", {
  minimumFractionDigits: 2,
});

const showDetails = () => {
  const setupAddonForm = () => {
    const observerTarget = document.querySelector("#productModal, form.cart");

    if (!observerTarget) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.target.classList.contains("show")) {
          updateAddonDetails(); // Update details when modal is opened
        }
      });
    });

    observer.observe(observerTarget, {
      attributes: true,
      attributeFilter: ["class"],
    });

    const updateAddonDetails = () => {
      const $addonDetailsList = $("#addonDetailsList");
      $addonDetailsList.empty().hide(); // Hide initially

      let hasValues = false;

      const form = $("form.cart")[0];
      if (!form) return;

      const formData = new FormData(form);
      const currency = $("#addonForm").data("currency_symbol");
      const basePrice = $("#addonForm").data('product_price') || 0;

      const quantity = parseInt(formData.get("quantity"), 10) || 1;
      const priceMultipliedByQuantity = basePrice * quantity;
      let subtotal = 0;

      // Append base product price
      const basePriceDisplay = $(`    
        <li class="addons-detail_item">
          <div class="addons-detail_col-1">${quantity} x ${$(
        "h3.product_title.modal-title"
      ).text()}</div>
          <div class="addons-detail_col-2">${currency}${currencyFormatter.format(
        priceMultipliedByQuantity
      )}</div>
        </li>
      `);
      $addonDetailsList.append(basePriceDisplay);

      // Process add-ons
      for (let pair of formData.entries()) {
        if (pair[0].indexOf("wc_product_addons") == 0) {
          const inputElement = $(
            `:not(input[type='checkbox']):not(input[type='radio'])input[name='${pair[0]}'], 
            textarea[name='${pair[0]}'], 
            select[name='${pair[0]}'],
            input[type='checkbox'][name='${pair[0]}'][value='${pair[1]}'],
            input[type='radio'][name='${pair[0]}']:checked`
          );

          const title = inputElement.data("name");
          let priceFloat = 0;
          let pricingType = false;

          if (inputElement.is("select")) {
            const selectedOption = inputElement.find("option:selected");
            priceFloat = parseFloat(selectedOption.data("price")) || 0;
            pricingType = selectedOption.data("pricing_type");
          } else {
            priceFloat = parseFloat(inputElement.data("price")) || 0;
            pricingType = inputElement.data("pricing_type");
          }
          
          console.log(pricingType);

          // Check for customer defined price
          if (inputElement.is(".addons-type_Form-price input[type='number']")) {
            priceFloat = parseFloat(pair[1]) || 0;
          }

          if (pricingType) {
            switch (pricingType) {
              case "quantity":
                priceFloat = priceFloat * quantity;
                break;
              case "percentage":
                priceFloat = (priceFloat / 100) * priceMultipliedByQuantity;
                break;
              default:
                break;
            }
          }

          const valueLabel = pair[1];

          // if (
          //   inputElement.attr("type") === "date" &&
          //   valueLabel.trim() !== ""
          // ) {
          //   const date = new Date(valueLabel);
          //   if (!isNaN(date)) {
          //     const options = {
          //       year: "numeric",
          //       month: "long",
          //       day: "numeric",
          //     };
          //     valueLabel = date.toLocaleDateString("en-US", options);
          //   } else {
          //     valueLabel = "";
          //   }
          // }

          if (valueLabel.trim() !== "") {
            hasValues = true;
            const listItem = $(`
            <li class="addons-detail_item">
            <div class="addons-detail_col-1">${title} - ${valueLabel}</div>
            <div class="addons-detail_col-2">${
              priceFloat
                ? `${currency}${currencyFormatter.format(priceFloat)}`
                : "-"
            }</div>
            </li>
            `);

            if (priceFloat) subtotal += priceFloat;
            $addonDetailsList.append(listItem);
          }
        }
      }

      // Show the details only if there are values
      if (hasValues) {
        $addonDetailsList.show();
      } else {
        $addonDetailsList.hide();
      }

      // Update subtotal
      const finalSubtotal = priceMultipliedByQuantity + subtotal;
      $(".subtotal-amount").text(
        `${currency}${currencyFormatter.format(finalSubtotal)}`
      );
    };

    $(document).on("input", "form.cart", updateAddonDetails);

    updateAddonDetails();

    // Prevent form submission if required fields are not filled
    // $(document).on("submit", "form.cart", function (e) {
    //   e.preventDefault();
    //   e.stopPropagation();
    //   if (validateBeforeAddToCart()) {
    //     $(this).closest("form.cart").trigger("submit");
    //   }
    // });

    // const validateBeforeAddToCart = () => {
    //   let isValid = true;

    //   $("#productModalBody form [data-restrictions]").each(function () {

    //     var validation_rules = $(this).data('restrictions');
    //     if ($.isEmptyObject(validation_rules)) {
    //       return true;
    //     }

    //     if (!('required' in validation_rules)) {
    //       return true;
    //     }

    //     if ('yes' !== validation_rules.required) {
    //       return true;
    //     }

    //     let fieldType = $(this).attr("type");

    //     if (fieldType === "checkbox" || fieldType === "radio") {
    //       let groupName = $(this).attr("name");
    //       let isChecked = $(`[name='${groupName}']:checked`).length > 0;

    //       if (!isChecked) {
    //         isValid = false;
    //         $(this)
    //           .closest(".addons-type_Form-checkbox, .addons-type_Form-radio")
    //           .find(".notif-required")
    //           .show();
    //       } else {
    //         $(this)
    //           .closest(".addons-type_Form-checkbox, .addons-type_Form-radio")
    //           .find(".notif-required")
    //           .hide();
    //       }
    //     } else {
    //       if (!$(this).val()) {
    //         isValid = false;
    //         $(this).next(".notif-required").show();
    //       } else {
    //         $(this).next(".notif-required").hide();
    //       }
    //     }
    //   });

    //   return isValid;
    // };
  };

  setupAddonForm();
};

try {
  $(() => showDetails());
} catch (e) {
  console.error("Cart Error:", e);
}
